import {
  Directive,
  HostListener,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal,
} from '@angular/core';

@Directive({
  selector: '[awCloseOnOffClick]',
})
export class CloseOnOffClick {
  private readonly isHovered: WritableSignal<boolean> = signal(false);
  public readonly onOffClick: OutputEmitterRef<boolean> = output();

  @HostListener('mouseover')
  onMouseOver() {
    this.isHovered.set(true);
  }
  @HostListener('mouseout')
  onMouseOut() {
    this.isHovered.set(false);
  }

  @HostListener('document:click')
  click() {
    if (!this.isHovered()) {
      this.onOffClick.emit(true);
    }
  }
}
